module.exports = __webpack_public_path__ + "media/images/map/swipe-up-arrow-75ea594402f3857886100e31873ae08d.svg";